import { FireIcon } from "@/components/conversations/activities/connect-moment/fire-icon";
import { PeriwinkleCard } from "@/components/conversations/activities/connect-moment/periwinkle-card";
import { UserAvatar } from "@/components/ui/stacked-avatars";
import { cn } from "@/lib/utils";

interface ConnectSummaryCardProps {
  isActive: boolean;
  ownerName: string;
  ownerAvatarUrl: string | undefined;
  teenName: string;
  teenAvatarUrl: string | undefined;
}

const RINGED_AVATAR_SIZE = 132;

export function ConnectSummaryCard({
  isActive,
  ownerName,
  ownerAvatarUrl,
  teenName,
  teenAvatarUrl,
}: ConnectSummaryCardProps) {
  return (
    <PeriwinkleCard
      variant="highlight"
      className={cn(
        "shrink-0 rounded-3xl transition-opacity",
        isActive ? "" : "opacity-70",
      )}
      style={{
        width: "84%",
        minHeight: 640,
        boxShadow: "0px 0px 16px 0px rgba(0,0,0,0.08)",
      }}
    >
      <div className="flex h-full flex-col items-center justify-center gap-2 px-6 pb-6 pt-9">
        <div
          className="mb-8 flex flex-row items-center justify-center"
          style={{ height: RINGED_AVATAR_SIZE }}
        >
          <UserAvatar
            imageUrl={ownerAvatarUrl}
            name={ownerName}
            size={RINGED_AVATAR_SIZE}
            showBorder
          />
          <div style={{ marginLeft: -40 }}>
            <UserAvatar
              imageUrl={teenAvatarUrl}
              name={teenName}
              size={RINGED_AVATAR_SIZE}
              showBorder
            />
          </div>
        </div>

        <h2 className="text-center text-[24px] font-bold leading-[28.8px] tracking-[-0.24px] text-white">
          Connection complete
        </h2>
        <p className="mt-2 px-4 text-center text-[14px] leading-[19.6px] tracking-[-0.14px] text-white">
          {teenName} made it through all 3 levels with you. Something real just
          happened here.
        </p>

        <div className="mt-10 flex flex-row items-center gap-3">
          {[0, 1, 2].map((i) => (
            <FireIcon key={i} size={36} />
          ))}
        </div>
      </div>
    </PeriwinkleCard>
  );
}
